import React,{ useEffect} from "react";
import { preLoaderAnim } from "./animations";
import './preLoader.css'

const PreLoader = () => {

  useEffect(() => {
    preLoaderAnim()
  }, []);
  return (
    <div className="preloader">
      <div className="texts-container">
        <span>Entrepreneur,</span>
        <span>Engineer,</span>
        <span>Developer.</span>
     </div>
    </div>
  );
};

export default PreLoader;
